import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  collapse: {
    marginBottom: 5,
    padding: 3,
    width: 'calc(100% + 6px)',
    marginLeft: -3
  },
  collapseClosed: {
    // Wrapped headers and their outline must fit inside the collapsed viewport.
    ...reskinStyles(theme, { minHeight: 'min-content !important' })
  },
  container: {
    position: 'relative',
    minHeight: 64,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'visible'
  },
  containerOpen: {
    position: 'relative',
    minHeight: 64,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'visible'
  },
  header: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: theme.sizes.roundCorners
  },
  buttonContainer: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    top: 8,
    right: 8,
    gap: 4,
    // Reskin: in the header's flex row, so delete/chevron center on headers of any height.
    ...reskinStyles(theme, { position: 'static', flexShrink: 0, marginRight: 8 })
  },
  iconButtonRoot: {
    color: theme.colors.action_icon,
    padding: 8
  },
  deleteIcon: {
    height: 24,
    width: 24
  },
  iconButtonLabel: {
    height: 32,
    width: 32
  },
  iconFold: {
    display: 'block',
    height: 32,
    width: 32,
    transition: 'transform 200ms'
  },
  icon: {
    composes: '$iconFold',
    transform: 'rotate(180deg)'
  },
  // `content` takes whatever width `contentRight` leaves and wraps inside it, so a long header (e.g. a
  // four-part driver name) breaks onto a second line instead of running under the actions.
  content: {
    minHeight: 64,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(3, 0, 3, 8),
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    flex: '1 1 0',
    minWidth: 0,
    overflowWrap: 'anywhere'
  },
  enclosedCard: {
    composes: '$content',
    padding: theme.spacing(3, 0, 3, 4)
  },
  // Clears the absolutely positioned delete/chevron buttons. A margin (not `right` offset) keeps that
  // gap in the flex layout; an offset moved the actions left over `content` without `content` knowing.
  contentRight: {
    marginRight: 56,
    ...reskinStyles(theme, { marginRight: 0 }),
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  noBorders: {
    paddingBottom: 0,
    marginBottom: 0,
    paddingTop: 0
  },
  hiddenContent: {
    display: 'none'
  }
});

export default styles;
